import React from "react";
import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";

import consult from "../../../assets/Android-app-dev/Simplified-dev-process/Consultant.svg";
import design from "../../../assets/Android-app-dev/Simplified-dev-process/Designing.svg";
import devlop from "../../../assets/Android-app-dev/Simplified-dev-process/developement.svg";
import launch from "../../../assets/Android-app-dev/Simplified-dev-process/Launch.svg";
import planning from "../../../assets/Android-app-dev/Simplified-dev-process/Planning.svg";
import protype from "../../../assets/Android-app-dev/Simplified-dev-process/Prototyping.svg";
import test from "../../../assets/Android-app-dev/Simplified-dev-process/Test.svg";

import android from "../../../assets/Android-app-dev/Our-andiroid-app-dev/App-Development.svg";
import uiux from "../../../assets/Android-app-dev/Our-andiroid-app-dev/UIUX.svg";
import web from "../../../assets/Android-app-dev/Our-andiroid-app-dev/Web-app.svg";
import multi from "../../../assets/Android-app-dev/Our-andiroid-app-dev/multi-platform.svg";

import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import FooterTwo from "../../../components/footer/FooterTwo";

import Banner from "../../../assets/Sub-component/Banner";

import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";
import CoreComponent9 from "../../../assets/Sub-component/CoreComponent9";

import CoreComponenet7 from "../../../assets/Sub-component/CoreComponenet7";

import CoreComponent10 from "../../../assets/Sub-component/CoreComponent10";
import HeaderThree from "../../../components/header/HeaderThree";
import { Helmet } from "react-helmet";
import CoreComponent4 from "../../../assets/Sub-component/CoreComponent4";

import CoreComponent23 from "../../../assets/Sub-component/CoreComponent23";
import DevelopmentProcessCore from "../../../assets/Sub-component/DevelopmentProcessCore";
import ModelCore from "../../../assets/Sub-component/ModelCore";
import CardCore from "../../../assets/Sub-component/CardCore";
import { Link } from "react-router-dom";

import Custom_Solutions from "../../../assets/Services/Web3_Dev/Why_Raiden_Labs/Custom_Solutions.svg";
import On_Time_Project_Delivery from "../../../assets/Services/Web3_Dev/Why_Raiden_Labs/On_Time_Project_Delivery.svg";
import Secure_Smart_Contracts from "../../../assets/Services/Web3_Dev/Why_Raiden_Labs/Secure_Smart_Contracts.svg";
import Transparent_Development from "../../../assets/Services/Web3_Dev/Why_Raiden_Labs/Transparent_Development-1.svg";
import Transparent_Development2 from "../../../assets/Services/Web3_Dev/Why_Raiden_Labs/Transparent_Development.svg";

import DeFi from "../../../assets/Services/Web3_Dev/Web3_Development_Services/DeFi.svg";
import Decentralized_Application from "../../../assets/Services/Web3_Dev/Web3_Development_Services/Decentralized_Application.svg";
import Metaverse_Solutions from "../../../assets/Services/Web3_Dev/Web3_Development_Services/Metaverse_Solutions.svg";
import NFT from "../../../assets/Services/Web3_Dev/Web3_Development_Services/NFT.svg";
import Smart_Contract from "../../../assets/Services/Web3_Dev/Web3_Development_Services/Smart_Contract.svg";
import Web3_Game from "../../../assets/Services/Web3_Dev/Web3_Development_Services/Web3_Game.svg";

import Direct_Connectivity from "../../../assets/Services/Web3_Dev/Benefits_of_Web3/Direct_Connectivity.svg";
import Personalized_User_Experiences from "../../../assets/Services/Web3_Dev/Benefits_of_Web3/Personalized_User_Experiences.svg";
import Smarter_Information from "../../../assets/Services/Web3_Dev/Benefits_of_Web3/Smarter_Information.svg";
import Total_Data_Ownership from "../../../assets/Services/Web3_Dev/Benefits_of_Web3/Total_Data_Ownership.svg";
import Transparent_Operations from "../../../assets/Services/Web3_Dev/Benefits_of_Web3/Transparent_Operations.svg";
import Uninterrupted_Services from "../../../assets/Services/Web3_Dev/Benefits_of_Web3/Uninterrupted_Services.svg";
import NftService from "./NftService";
import web3_img from '../../../assets/Services/Web3_Dev/web3_img.png'
import FaqHome from "../../../components/faq/FaqHome";
import launchingimage from '../../../assets/Launchingimage.png'
const Web3Development = () => {
  const models = [
    {
      title: "Hourly Model",
      desc: "Rapid bootstrapping in 24 hours",
      desc2: " short-term or task-oriented ",
      desc3: "Billing: Daily / Weekly / Monthly",
      desc4: "Duration: 8 hours/day, 5 days/week",
      desc5: "Minimum: 50 hours",
    },
    {
      title: " Part-Time Model",
      desc: "Begin in 48 hours",
      desc2: "Ideal for regular or lighter workloads",
      desc3: "Billing: Weekly / Monthly",
      desc4: "Flexible scheduling",
      desc5: "Minimum: 50 hours",
    },
    {
      title: " Full-Time Dedicated Model",
      desc: "Your project's sole dedicated developer",
      desc2: "Begin within 72 hours",
      desc3: "Billing: Monthly",
      desc4: "Duration: According to project scope",
      desc5: "Minimum: 50 hours",
    },
  ];

  const timelineData = [
    {
      heading: "Strategic Planning",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "We start with learning about your business goals to develop a customized Web3 development strategy that is in line with your needs.",
    },
    {
      heading: "White Paper Drafting",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "After the vision has been approved, our expert team drafts a comprehensive white paper detailing the business and technical features of your project.",
    },
    {
      heading: " Design & Development",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "According to the white paper, we develop secure Web3 applications that represent your brand and provide performance, security, and scalability.",
    },
    {
      heading: "Smart Contract Deployment",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "Our developers create and implement smart contracts to protect your platform and facilitate smooth, transparent transactions.",
    },
    {
      heading: "Quality Assurance & Testing",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "We perform multi-level testing to make your Web3 app secure, efficient, and totally optimized before it goes live.",
    },
    {
      heading: " Launch & Handover",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "When the solution is prepared, we help you launch your Web3 platform and offer all required credentials and documentation.",
    },
  ];

  const content = [
    {
      icon: Decentralized_Application,
      title: "Decentralized Application (dApp) Development",
      desc: "Being a top Web3 Mobile App Development agency, we develop secure, scalable, and interoperable dApps based on technologies such as Solidity, Rust, Golang, and frameworks such as Brownie and Substrate.",
    },
    {
      icon: DeFi,
      title: "DeFi (Decentralized Finance) Development",
      desc: "Our DeFi development solutions cover custom DeFi dApps, non-custodial wallets, tokens, and AMMs. We offer strategic consulting and strong development to enable you to go live with high-performing DeFi ecosystems.",
    },
    {
      icon: Metaverse_Solutions,
      title: "Metaverse Solutions",
      desc: "From rich 3D worlds to NFTs and AR/VR experiences, we create Metaverse assets that provide real commercial value. Our USA-based team designs influential digital worlds with advanced Web3 technologies.",
    },
    {
      icon: NFT,
      title: "NFT Marketplace Development",
      desc: "We build customized NFT marketplace platforms for live auctions, effortless trading, and integration with our clients' existing apps. We make available fast-deploy, scalable NFT solutions",
    },
    {
      icon: Smart_Contract,
      title: "Smart Contract Development",
      desc: "As a reliable Web3 game development service provider in Saudi Arabia, we build secure, auditable, and upgradable smart contracts based on current Web3 standards through composable and open-source backends.",
    },
    {
      icon: Web3_Game,
      title: "Web3 Game Development",
      desc: "Using Unreal Engine 5 and Unity, we create NFT-powered and play-to-earn multiplayer games. Our team tracks global gaming trends to develop innovative, high-performance Web3 gaming experiences.",
    },
  ];

  const imgcontent = [
    {
      line: "demooo",
      icon: consult,
      title: "Build",
      desc: "We meticulously code your Android app, bringing your vision to life.",
    },
    {
      line: "demooo",
      icon: design,
      title: "Design",
      desc: "Our team crafts a stunning, intuitive look for a delightful user experience.",
    },
    {
      line: "demooo",
      icon: devlop,
      title: "Crafting",
      desc: "Get a clickable demo to visualize and refine your Android app's features early.",
    },
    {
      icon: launch,
      title: "Launch",
      desc: "We handle the final steps, ensuring your Android app is successfully published and ready for millions to discover on the Google Play Store.",
    },
    {
      line: "line-div",
      icon: planning,
      title: "Refine",
      desc: "We rigorously test your Android app to guarantee it's bug-free and performs flawlessly across all devices.",
    },
    {
      line: "line-div",
      linebottom: true,
      icon: protype,
      title: "Creation",
      desc: "We'll map out every step for a successful Android app build.",
    },
    {
      line: "line-div",
      icon: test,
      title: "Journey",
      desc: "We start by understanding your goals, ensuring your Android app perfectly fits your business.robust ",
    },
  ];

  const comp11 = [
    {
      title:
        "Hava a web3 development  idea? ",
        desc:'Raiden makes your vision a digital success.'
    },
  ];

  const banner = [
    {
      title: "Curious about what it's like to work here?",
      desc: "A group of skilled developers has been brought together to maximize the efficiency of your business, so prepare to release an application.",
      title2: "Curious about what it's like to work here?",
    },
  ];

  const rounded = [
    {
      title: "Custom Solutions",
      desc: "We design personalized Web3 platforms for your business objectives and market needs.",
      icon: Custom_Solutions,
    },
    {
      title: " Secure Smart Contracts",
      desc: "Our experts develop bug-free smart contracts crafted to avoid vulnerabilities and hacks.",
      icon: Secure_Smart_Contracts,
    },
    {
      title: "Transparent Development",
      desc: "We provide full visibility across the project life cycle—technology, timelines, and costs",
      icon: Transparent_Development,
    },
    {
      title: "Trustworthy Support Team",
      desc: "Our technical experts in blockchain offer continuous support and advice throughout the development stages.",
      icon: Transparent_Development2,
    },
    {
      title: "On-Time Project Delivery",
      desc: "We adhere to timelines and deliver your Web3 product on time without sacrificing quality.",
      icon: On_Time_Project_Delivery,
    },
  ];
  const card = [
    {
      title: " Total Data Ownership",
      icon: Total_Data_Ownership,
      desc: "Users have complete transparency over what they share, which improves privacy by using web3, users can own their data without any issues",
    },
    {
      title: " Direct Connectivity",
      icon: Direct_Connectivity,
      desc: "Web3 allows companies to reach users directly without any intermediaries and keep more value.",
    },
    {
      title: "Transparent Operations",
      icon: Transparent_Operations,
      desc: "All actions on a Web3 site are trackable and traceable, building trust and accountability.",
    },
    {
      title: "Smarter Information Discovery",
      icon: Smarter_Information,
      desc: "Web3 provides better search results with more accurate and relevant information through improved semantic and contextual intelligence.",
    },
    {
      title: "Personalized User Experiences",
      icon: Personalized_User_Experiences,
      desc: "With AI-powered insights, users have a super personalized and adaptive web experience.",
    },
    {
      title: "Uninterrupted Services",
      icon: Uninterrupted_Services,
      desc: "Through decentralized storage and distributed nodes, Web3 platforms are not vulnerable to disruptions and outages.",
    },
  ];

  return (
    <div>
     <img 
  src={launchingimage} 
  className="Bg-image"
  alt="Launching"
/>

      <div>
        <div className="main-page-wrapper">
          <Helmet>
            <title>
              Customer Support || Deski-Saas & Software React Template
            </title>
          </Helmet>

          <HeaderThree />

          <div
            className=" container  d-flex align-items-center justify-content-center flex-column  topheader-margin"
            style={{ minHeight: "100vh" }}
          >
            <h1 className="fw-bold text-center h1-heading lh-sm">
              Web3 Development Company
            </h1>
            <h3 className="h3-heading mt-2">
              {" "}
              Raiden Labs – Your Reliable Web3 Development Partner
            </h3>
            <p className="text-center mt-4 mb-4 h1-para lh-base">
              We are a high-quality Web3 development agency that is dedicated to
              creating future-proof digital solutions based on AI, NFTs, IoT,
              Cryptography, and Blockchain technologies. With strong know-how in
              tools, oracles, APIs, and programming languages like Solidity and
              Rust, we provide creative, cost-effective Web3 solutions to match
              your business requirements.
            </p>
            <div className="d-flex ">
              <Link to="/request-quote">
                <button className="h1-para mt-lg-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
                  Get Your Free Quote
                </button>
              </Link>
            </div>
          </div>

          <div className=" bg-light">
            <div className=" container pt-60 pb-60 padt padb ">
              <div className=" row mb-80 marb  ">
                <h2 className="col-lg-6 lh-sm  h2-heading mb-3 mb-lg-0">
                  Web3 Development Services We Offer
                </h2>
                <p className="col-lg-6  h1-para lh-base">
                  Our skilled Web3 developers in Dubai offer end-to-end Web3
                  services that unleash business potential, enhance business
                  operations efficiency, and boost user experience through
                  innovative digital platforms.
                </p>
              </div>
              <div>
                <CoreComponent4 content={content} />
              </div>
            </div>
          </div>

          <div className="container pt-80 padt  pb-20">
            <div className=" row">
              <div className="col-lg-4 text-center">
                <img src={web3_img} style={{ width: "" }} alt="web3_img" />
              </div>
              <div className="col-lg-8 my-auto ">
                <h2 className=" lh-sm  h2-heading ">Understanding Web3</h2>
                <p className="mt-lg-4  mt-3 h1-para lh-base">
                  Web 3 helps us to connect with others in any type of media
                  without any loss of privacy. It makes the internet smarter.
                  with the help of AI and big data. It can also manage the
                  procedure of data collection and management by using
                  blockchain
                </p>
              </div>
            </div>
          </div>

          <div className="mt-80 mart ">
            <CoreComponent10 comp10={comp11} />
          </div>

          <div className="  bg-light mt-80 mart ">
            <div className="container">
              <h2 className=" text-center pt-60 padt lh-sm  h2-heading">
                Our Web3 Development Process
              </h2>
              <p className="text-center mt-ld-4 mt-3 h1-para lh-base  ">
                Our Web3 development process is streamlined, agile, and
                security-focused—covering everything from smart contract
                creation to full-stack dApp deployment. We ensure scalable,
                user-centric solutions built on the latest decentralized
                technologies.
              </p>
              <DevelopmentProcessCore timelineData={timelineData} />
            </div>
          </div>
          <div className="container text-center pt-80 padt ">
            <h2 className=" lh-sm  h2-heading">
              {" "}
              Benefits of Web3 for Businesses
            </h2>
            <p className="my-3  h1-para lh-base">
              {" "}
              Web3 empowers businesses with decentralized, secure, and
              transparent systems that enhance trust and data ownership. It also
              enables new revenue models through tokenization, smart contracts,
              and borderless digital operations.
            </p>
            <CardCore card={card} />
          </div>

          <div className="mt-80 container text-center marb ">
            <h2 className=" lh-sm  h2-heading">
              Why Raiden Labs for Web3 Development
            </h2>
            <p className=" my-lg-4 my-lg-3 my-2 h1-para lh-base">
              Raiden Labs combines deep blockchain expertise with innovative
              design to deliver secure, scalable, and user-focused Web3
              solutions. Our agile approach ensures faster deployment, seamless
              integration, and long-term value for your business.
            </p>

            <div>
              <CoreComponent23 rounded={rounded} />
            </div>
          </div>

          <div className="container mt-80 mart ">
            <h2 className="text-center  lh-sm  h2-heading">
              Our Android App Development Approach
            </h2>
            <p className="text-center my-lg-3 my-2  pb-lg-3 h1-para lh-base">
              Our methodology leads your project from conception to successful
              implementation by fusing creative design with robust engineering
              for long-term functionality.
            </p>
            <CoreComponenet7 imgcontent={imgcontent} />
          </div>

          <div className="container text-center mt-80 mart  ">
            <h2 className=" lh-sm  h2-heading">
              Mastering the Full Spectrum of Web3 Development
            </h2>
            <p className="my-3 h1-para lh-base">
              Excellence and Successful Execution
            </p>
            <CoreComponent9 />
          </div>

          <div className=" pt-100 mt-80  container pb-80 mart padb ">
            <h2 className="mb-4 pb-lg-2 text-center  h2-heading  lh-base">
              Flexible Engagement Models
            </h2>
            <ModelCore models={models} />
          </div>

          <div>
            <CoreComponent2 />
          </div>

          <div className="border-y-div m-0">
            <Banner banner={banner} />
          </div>

          <div className="">
            <OurLatestBlogs />
          </div>
          {/* <FaqHome/> */}
          <footer className="theme-footer-two pt-80 padt ">
            <div className="top-footer">
              <div className="container">
                <FooterTwo />
              </div>
            </div>
            <div className="container">
              <div className="bottom-footer-content">
                <CopyRightTwo />
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Web3Development;
